'use client';

import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

const NetSound = ({ data }) => {
  const [prevData, setPrevData] = useState(null);
  const audioRef = useRef(null);
  const toggleReducer = useSelector((state) => state.toggleReducer);

  useEffect(() => {
    if (!audioRef.current) {
      audioRef.current = new Audio('/net88.mp3');
    }

    if (prevData !== null && data !== prevData && toggleReducer.sound === true) {
      audioRef.current.play();
    }
    
    setPrevData(data);

    return () => {
      // audioRef.current.pause();
      // audioRef.current.currentTime = 0;
    };
  }, [data, prevData]);

  return <></>;
};

export default NetSound;